import { useLocation } from '@reach/router';
import * as queryString from 'query-string';
import { z } from 'zod';

export function usePreviewParameters() {
  const schema = z
    .object({
      nid: z.string(),
      rid: z.string(),
      lang: z.string(),
    })
    .required();
  const search = useLocation().search;
  return search
    ? schema.parse(queryString.parse(search))
    : {
        nid: '',
        rid: '',
        lang: '',
      };
}

export function isPreviewPath(path: string) {
  return path.startsWith('/__preview/');
}
